import { MatcherTypes } from "../../types/rules/MatcherTypes";
import { Matcher, MatcherProperties } from "./Matcher";

type RegexMatcherData = {
  regex: string;
} & MatcherProperties;

class RegexMatcher extends Matcher implements RegexMatcherData {
  discriminator: MatcherTypes = "M_REGEX";
  /* Regex Matcher properties */
  regex: string;
  /* Matcher properties */
  position: number;
  threshold: number;
  reusable: boolean;

  constructor(data: RegexMatcherData) {
    super();
    this.regex = data.regex ?? "";
    this.position = data.position;
    this.reusable = data.reusable ?? true;
    this.threshold = data.threshold;
  }
  isConfigured(): boolean {
    return this.regex !== "";
  }
  clear(): void {
    this.regex = "";
  }

  toMatcherData(): RegexMatcherData {
    return {
      discriminator: this.discriminator,
      position: this.position,
      regex: this.regex,
      reusable: this.reusable,
      threshold: this.threshold,
    };
  }

  getDiscriminator(): MatcherTypes {
    return this.discriminator;
  }
  getReusable(): boolean {
    return this.reusable;
  }
  setReusable(value: boolean): void {
    this.reusable = value;
  }

  getMatcherId(): string {
    return `${this.discriminator}-${this.regex}`;
  }

  static createTest(rest: Partial<RegexMatcherData> = {}): RegexMatcher {
    const data: RegexMatcherData = {
      regex: "",
      position: 0,
      reusable: true,
      discriminator: "M_REGEX",
      threshold: 0,
    };

    return new RegexMatcher({
      ...data,
      ...rest,
    });
  }
}

export { RegexMatcher, RegexMatcherData };
